// Feature switches. Code stays in place; flip to true to show again.
// Server mirror for the promo: PROMO_ENABLED in supabase/functions/_shared/stripe.ts.
export const UPSELLS_ENABLED = true; // Pro upsell banners, popups and $1.99 intro promo
export const REFERRALS_ENABLED = true; // Invite friends page, /r/:code links, signup claim
export const REFERRAL_NAV_ENABLED = false; // Sidebar "Invite friends" link only
